<template>
    <div :class="{ show: y >= 100 }">
        <SearchLogo :showTips="false" />
    </div>
</template>
<script lang="ts">
import { reactive, ref, defineComponent, onMounted } from 'vue';
import SearchLogo from './Search/SearchLogo.vue';
import { useWindowScroll } from '@vueuse/core';
import VueCookies from 'vue-cookies';
import loginApi from '@/api/PcModule/login';
export default defineComponent({
    name: 'WindowScroll',
    components: {
        SearchLogo,
    },
    setup() {
        const { x, y } = useWindowScroll();
        onMounted(() => {
            if (
                performance.navigation.type ==
                performance.navigation.TYPE_RELOAD
            ) {
                if (getTime() < 120) {
                    refreshtoken();
                }
            }
        });
        window.addEventListener('click', (e) => {
            if (
                location.pathname != '/login' &&
                localStorage.getItem('refresh_token')
            ) {
                if (getTime() < 120) {
                    refreshtoken();
                }
            }
        });
        // 以分为单位
        const getTime = () => {
            let timer = localStorage.getItem('expires_in');
            const currentTime = new Date();
            const targetTime = new Date(timer);
            const timeDiff = targetTime.getTime() - currentTime.getTime();
            const ret = Math.floor(timeDiff / (1000 * 60));
            return ret;
        };
        const refreshtoken = async () => {
            let params = {
                grant_type: 'refresh_token',
                refresh_token: localStorage.getItem('refresh_token'),
            };
            let data = await loginApi.LoginCodeUser(params);
            if (data.access_token) {
                localStorage.setItem('token', data.access_token);
                localStorage.setItem('refresh_token', data.refresh_token);
                const now = new Date();
                now.setSeconds(now.getSeconds() + data.expires_in + 28800);
                localStorage.setItem('expires_in', now);
                VueCookies.set(
                    'token',
                    data.access_token,
                    data.expires_in + 28800
                );
            } else {
                localStorage.setItem('token', '');
                localStorage.setItem('shop', '{}');
                localStorage.setItem('user', JSON.stringify({userInfo: {}}));
                localStorage.setItem('refresh_token', '');
                localStorage.setItem('expires_in', '');
                VueCookies.remove('token', null);
                location.replace(
                    `${import.meta.env.VITE_BASE_HOST}${location.search}`,
                );
            }
        };
        return { y };
    },
});
</script>
<style scoped lang="scss">
.scroll {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    background-color: #fff;
    // border-bottom: 1px solid #e4e4e4;
    // 此处为关键样式!!!
    // 默认情况下完全把自己移动到上面
    // transform: translateY(-100%);
    // 完全透明
    // opacity: 0;
    // 显示出来的类名
    // &.show {
    //     transition: all 0.3s linear;
    //     transform: none;
    //     opacity: 1;
    // }
}
</style>
